export const FLOOR_MAT_API_KEY = "QtWh19sSmZf975jECj8AT0x6msyUJD52";
export const FLOOR_MAT_DOMAIN_NAME = "https://beverlyhillsmotoring.com";
export const FLOOR_MAT_BRAND_CODE = "CLRB";
export const FLOOR_MAT_PRODUCT_LINE_CODE = "BB";